import { render, staticRenderFns } from "./DatarowsViewer.vue?vue&type=template&id=e60d653e"
import script from "./DatarowsViewer.vue?vue&type=script&lang=js"
export * from "./DatarowsViewer.vue?vue&type=script&lang=js"
import style0 from "./DatarowsViewer.vue?vue&type=style&index=0&id=e60d653e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports